import {of} from 'rxjs';
import {catchError, filter, mergeMap} from 'rxjs/operators';
import {isActionOf, RootEpic} from 'typesafe-actions';

import {pushRoute} from '../../../routes';
import {IRxAxiosError} from '../../../shared';
import {debugAction} from '../../../store/system/actions';
import {clearData} from '../../election/store/actions';
import {
  loadUserAsync,
  loginAuthAsync,
  logoutAuthAsync,
  setAuthToken,
  setUser,
  updatePwdAsync,
} from './actions';

export const loginAuthEpic: RootEpic = (action$, state$, {authApi}) => {
  return action$.pipe(
    filter(isActionOf(loginAuthAsync.request)),
    mergeMap(action =>
      authApi.signIn(action.payload).pipe(
        mergeMap(token =>
          of(loginAuthAsync.success(token), setAuthToken(token))
        ),
        catchError((error: IRxAxiosError) =>
          of(loginAuthAsync.failure(error.message))
        )
      )
    )
  );
};

export const setUserAuthEpic: RootEpic = (action$, state$, {authApi}) =>
  action$.pipe(
    filter(isActionOf(setAuthToken)),
    mergeMap(action => {
      authApi.setToken(action.payload);
      return of(debugAction('Stored Token!'), loadUserAsync.request());
    })
  );

export const loadUserEpic: RootEpic = (action$, state$, {authApi}) => {
  return action$.pipe(
    filter(isActionOf(loadUserAsync.request)),
    mergeMap(action =>
      authApi.me().pipe(
        mergeMap(user =>
          of(loadUserAsync.success(), setUser(user), pushRoute('home'))
        ),
        catchError((error: IRxAxiosError) =>
          of(loadUserAsync.failure(error.message))
        )
      )
    )
  );
};

export const logoutAuthEpic: RootEpic = (action$, state$, {authApi}) =>
  action$.pipe(
    filter(isActionOf(logoutAuthAsync.request)),
    mergeMap(action =>
      authApi.requestLogout().pipe(
        mergeMap(user =>
          of(logoutAuthAsync.success(), clearData(), pushRoute('auth'))
        ),
        catchError((error: IRxAxiosError) =>
          of(
            logoutAuthAsync.failure(error.message),
            clearData(),
            pushRoute('auth')
          )
        )
      )
    )
  );

export const updatePwdEpic: RootEpic = (action$, state$, {authApi}) => {
  return action$.pipe(
    filter(isActionOf(updatePwdAsync.request)),
    mergeMap(action =>
      authApi.updatePassword(action.payload).pipe(
        mergeMap(user =>
          of(updatePwdAsync.success(), setUser(user), pushRoute('home'))
        ),
        catchError((error: IRxAxiosError) =>
          of(updatePwdAsync.failure(error.message))
        )
      )
    )
  );
};



// WEBPACK FOOTER //
// ./src/features/auth/store/epics.ts